import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';

// Only English is bundled with the marketing entry. The other ten locales
// are dynamic-imported on demand by `loadLocale()` below, called from
// LanguageProvider before any `setCurrentLanguage(non-en)` runs. Keeps
// ~890 KB raw (~250 KB gzipped) off the marketing critical path.
//
// SSR renders in English; the post-hydration locale-resolution effect
// (see LanguageProvider) hides <html> via the flicker guard until the
// user's locale chunk lands and the language switch settles.

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

const localeLoaders: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  es: () => import('../locales/es.json'),
  fr: () => import('../locales/fr.json'),
  de: () => import('../locales/de.json'),
  it: () => import('../locales/it.json'),
  pt: () => import('../locales/pt.json'),
  uk: () => import('../locales/uk.json'),
  ro: () => import('../locales/ro.json'),
  ru: () => import('../locales/ru.json'),
  pl: () => import('../locales/pl.json'),
  nl: () => import('../locales/nl.json'),
};

export async function loadLocale(code: string): Promise<void> {
  if (code === 'en') return;
  if (i18n.hasResourceBundle(code, 'translation')) return;
  const loader = localeLoaders[code];
  if (!loader) return;
  try {
    const mod = await loader();
    i18n.addResourceBundle(code, 'translation', mod.default, true, true);
  } catch (err) {
    console.warn(`Failed to load locale ${code}`, err);
  }
}

export default i18n;
